import { Input, Card, Button, Modal, Tag } from "antd";
import Table, { ColumnsType } from "antd/lib/table";

import { TableHelper } from "../../util/TableHelper";
import Loading from "../common/Loading";
import { useSupportQuery } from "./index.hook";
import CustomerLocationFilter from "../common/CustomerLocationFilter";
import styles from "./index.module.less";

import type { SupportQueryRecord } from "../../shared/interface/SupportQuery.interface";

const SupportQuery = () => {
  const config = useSupportQuery();

  const columns: ColumnsType<SupportQueryRecord> = [
    {
      align: "left",
      title: "Sr. No",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      }
    },
    {
      align: "left",
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
      sorter: {
        compare: TableHelper.valueCompare("user")
      }
    },
    {
      align: "left",
      title: "Query Type",
      dataIndex: "query_type",
      key: "query_type",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("query_type")
      }
    },
    {
      align: "left",
      title: "Complaint Date",
      dataIndex: "created_on",
      key: "created_on",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.dateSorter("created_on")
      }
    },
    {
      align: "left",
      title: "Complaint",
      dataIndex: "query",
      key: "query",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("query")
      }
    },
    {
      align: "center",
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Tag className="gx-text-center gx-m-0" color={text == "OPEN" ? "green" : "error"}>
          {text ?? ""}
        </Tag>
      ),
      sorter: {
        compare: TableHelper.valueCompare("status")
      },
      width: "10%"
    },
    {
      align: "center",
      title: "Action",
      key: "action",
      render: (_, record) =>
        !record.is_closed ? (
          <Button className="gx-mb-0 button-gradiant" onClick={() => config.openModal(record)}>
            CLOSE
          </Button>
        ) : null,
      width: "10%"
    }
  ];

  return (
    <Card className="gx-card card--height" title={null}>
      <div className={styles["head-container"]}>
        <div className={styles["left-section"]}>
          <div className="card-title-style">Support Query</div>
        </div>
        <div className={styles["right-section"]}>
          <CustomerLocationFilter selectedCustomerId={config.selectedCustomerId} selectedLocationId={config.selectedLocationId} handleChangeCustomer={config.handleChangeCustomer} handleChangeLocation={config.handleChangeLocation} />
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} value={config.searchedText} onChange={(e) => config.handleChangeSearch(e.target.value)} onSearch={config.handleChangeOnSearch} />
        </div>
      </div>
      {config.loading && <Loading />}

      {!config.loading && <Table className="gx-table-responsive fixed-table-layout gx-mt-4" size="small" columns={columns} dataSource={config.supportQueryData} pagination={config?.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.sr_no} />}

      <Modal title="Confirm Close" visible={config.isModalVisible} onOk={config.handleConfirmClose} onCancel={config.handleCancelClose} okText="Confirm" cancelText="Cancel">
        <p>Are you sure you want to close this query?</p>
        <p>This action cannot be revert back.</p>
      </Modal>
    </Card>
  );
};

export default SupportQuery;
